import { useState } from "react";
import { FaCheck, FaUndo, FaPalette } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
    THEME_PRESETS,
    getSavedTheme,
    applyAndSaveTheme,
    applyCustomColor,
    resetToDefaultTheme
} from "../utils/theme";

import "./ManageAdmins.css";
import "./ThemeSettings.css";

function ThemeSettings() {

    const [current, setCurrent] = useState(getSavedTheme());

    const [customHex, setCustomHex] = useState(current.primary || "#2563eb");

    const handlePickPreset = (preset) => {

        applyAndSaveTheme(preset);

        setCurrent(preset);

        setCustomHex(preset.primary);

        toast.success(`Theme set to ${preset.label}.`);

    };

    const handleCustomColorChange = (e) => {

        const hex = e.target.value;

        setCustomHex(hex);

        const theme = applyCustomColor(hex);

        setCurrent(theme);

    };

    const handleReset = () => {

        const theme = resetToDefaultTheme();

        setCurrent(theme);

        setCustomHex(theme.primary);

        toast.success("Reset to the default theme.");

    };

    return (

        <div className="page">

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnHover
            />

            <div className="page-header">

                <div>
                    <h2><FaPalette /> Theme Settings</h2>
                    <p className="page-subtitle">
                        Changes apply immediately and are saved to this browser only - each person who
                        logs in can pick their own theme without affecting anyone else's. Affects the
                        primary action color used for buttons, focus states, and highlights across
                        every admin_UI page.
                    </p>
                </div>

                <button type="button" className="add-btn" onClick={handleReset}>
                    <FaUndo /> Reset to Default
                </button>

            </div>

            <div className="inline-form-container">

                <div className="inline-form-header">
                    <h3>Presets</h3>
                </div>

                <div className="theme-preset-grid">

                    {THEME_PRESETS.map(preset => (

                        <button
                            type="button"
                            key={preset.key}
                            className={`theme-preset-swatch ${current.key === preset.key ? "selected" : ""}`}
                            onClick={() => handlePickPreset(preset)}
                            title={preset.label}
                        >

                            <span
                                className="theme-preset-color"
                                style={{ background: preset.primary }}
                            >
                                {current.key === preset.key && <FaCheck />}
                            </span>

                            <span className="theme-preset-label">{preset.label}</span>

                        </button>

                    ))}

                </div>

                <div className="inline-form-header" style={{ marginTop: "24px" }}>
                    <h3>Custom Color</h3>
                </div>

                <div className="theme-custom-row">

                    <input
                        type="color"
                        value={customHex}
                        onChange={handleCustomColorChange}
                        className="theme-custom-picker"
                    />

                    <span className="theme-custom-hex">{customHex}</span>

                    <span className="theme-custom-hint">
                        Pick any color - a matching hover shade and light tint are generated automatically.
                    </span>

                </div>

                <div className="inline-form-header" style={{ marginTop: "24px" }}>
                    <h3>Live Preview</h3>
                </div>

                <div className="theme-preview-row">

                    <button type="button" className="add-btn" onClick={(e) => e.preventDefault()}>
                        Sample Button
                    </button>

                    <input placeholder="Sample input (click to see focus color)" className="theme-preview-input" />

                </div>

            </div>

        </div>

    );

}

export default ThemeSettings;
